import { render, staticRenderFns } from "./teaching.vue?vue&type=template&id=74560c36"
import script from "./teaching.vue?vue&type=script&lang=js"
export * from "./teaching.vue?vue&type=script&lang=js"
import style0 from "./teaching.vue?vue&type=style&index=0&id=74560c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports